import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';


export const WebHotelierErrorPage = React.memo(()=>{
return <div className="min-h-full bg-white">
	<div className="flex lg:h-dvh content-center justify-center flex-1">
		<div className="flex flex-1 flex-col justify-center px-6 py-12">
			<div className="mx-auto w-full max-w-sm lg:w-96">
				<div>
					<Link to="https://www.roompulse.io">
						<img
							className="h-10 w-auto"
							src="assets/img/brand/logo-icon.png"
							alt="RoomPulse"
						/>
					</Link>
					<h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
						Having Trouble Logging In?
					</h2>
					<p className="mt-2 text-sm leading-6 text-gray-500">
						Don't worry, we're here to help!
					</p>
				</div>

				<div className="mt-10">
					<div>
						<form action="#" method="POST" className="space-y-6">
							<div className="rounded-md bg-yellow-50 p-4">
								<div className="flex">
									<div className="flex-shrink-0">
										<ExclamationTriangleIcon className="h-5 w-5 text-yellow-400"/>
									</div>
									<div className="ml-3">
										<div className="text-sm text-yellow-700">
											<p>Something went wrong with your access. Please contact support.</p>
										</div>
									</div>
								</div>
							</div>
							<div>
								<Link to="/sign-in" className="btn btn-primary w-full" title="Click to sign in to your account">Go back to sign in</Link>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<div className="relative hidden flex-1 lg:block">
			<img
				className="absolute inset-0 h-full w-full object-cover object-left"
				src="https://images.unsplash.com/photo-1634712282287-14ed57b9cc89?q=80&w=2706&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
				alt=""
			/>
		</div>
	</div>
</div>
})